import React from "react";

/**
 * Componente ExpenseFilters para filtrar gastos por nombre y categoría
 * 
 * @param {Object} props
 * @param {string} props.search - Valor del campo de búsqueda
 * @param {Function} props.setSearch - Función para actualizar el campo de búsqueda
 * @param {string} props.filterCategory - ID de categoría seleccionada
 * @param {Function} props.setFilterCategory - Función para actualizar la categoría filtrada
 * @param {Array} props.categoryIds - Array de IDs de categorías disponibles
 * @param {Function} props.getCategoryLabel - Función para obtener el label de una categoría
 */
const ExpenseFilters = ({ search, setSearch, filterCategory, setFilterCategory, categoryIds, getCategoryLabel }) => (
  <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-4 mb-6 flex flex-wrap gap-3 items-center">
    <div className="flex-1 min-w-[180px]">
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Buscar por nombre..."
        className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      />
    </div>
    <div className="min-w-[160px]">
      <select
        value={filterCategory}
        onChange={(e) => setFilterCategory(e.target.value || "")}
        className="w-full px-4 py-2.5 border border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
      >
        <option value="">Todas las categorías</option>
        {categoryIds.map((catId) => (
          <option key={catId} value={catId}>{getCategoryLabel(catId)}</option>
        ))}
      </select>
    </div>
    {(search || filterCategory) && (
      <button
        onClick={() => { setSearch(""); setFilterCategory(""); }}
        className="px-3 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
      >
        Limpiar filtros
      </button>
    )}
  </div>
);

export default ExpenseFilters;
